import React from 'react'
import { Button } from 'react-bootstrap'

const RowItem = ({ node, level, expanded, onToggle, onSelect, selected }) => {
  const indent = { paddingLeft: `${level * 16}px` }
  return (
    <div className={`d-flex align-items-center py-1 ${selected ? 'bg-light' : ''}`} style={indent}>
      {!node.isLeaf && (
        <Button size='sm' variant='light' className='me-2' onClick={() => onToggle(node._id)}>
          <i className={`fas fa-chevron-${expanded ? 'down' : 'right'}`} />
        </Button>
      )}
      {node.isLeaf && <span className='me-2' style={{ width: 28 }} />}
      <Button size='sm' variant={selected ? 'primary' : 'outline-secondary'} onClick={() => onSelect(node._id)}>
        {node.name}
      </Button>
    </div>
  )
}

export default function CategoryTree({ byId, childrenByParent, rootIds, expandedIds, onToggleExpand, onSelectNode, selectedId }) {
  const renderBranch = (parentId, level = 0) => {
    const key = parentId == null ? 'null' : String(parentId)
    const ids = childrenByParent?.[key] || []
    return ids.map((id) => {
      const node = byId[id]
      if (!node) return null
      const expanded = expandedIds?.has(id)
      return (
        <div key={id}>
          <RowItem
            node={node}
            level={level}
            expanded={expanded}
            onToggle={onToggleExpand}
            onSelect={onSelectNode}
            selected={selectedId === id}
          />
          {!node.isLeaf && expanded && renderBranch(id, level + 1)}
        </div>
      )
    })
  }

  return <div>{renderBranch(null, 0)}</div>
}
